import React from 'react';
import { TestimonialProps } from '..';
import colors from '../../../helpers/colors';
import componentProps from '../../../helpers/componentProps';
import { applyComponentTheme } from '../../../theme';
import TestimonialCardDoubleMarks from './TestimonialCardDoubleMarks';
import { GridItemFlex, Heading, TestimonialGrid, TestimonialWrapper } from './styles';

const Testimonial: React.FC<TestimonialProps> = ({
  headerText,
  testimonials,
  icon = 'speech-bubble',
  showAuthor,
  ...props
}) => (
  <TestimonialWrapper {...componentProps(props)}>
    {headerText && <Heading tabIndex={0}>{headerText}</Heading>}
    <TestimonialGrid role="list">
      {testimonials.map((testimonial) => (
        <GridItemFlex
          desktop={8}
          tabletLandscape={8}
          tabletPortrait={8}
          key={testimonial.quote}>
          <TestimonialCardDoubleMarks
            icon={icon}
            quote={testimonial.quote}
            author={testimonial.author}
            showAuthor={showAuthor}
            themeColor={colors.core01}
            screenReaderText={testimonial.screenReaderText}
          />
        </GridItemFlex>
      ))}
    </TestimonialGrid>
  </TestimonialWrapper>
);

export default applyComponentTheme(Testimonial, 'Testimonial');
